import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { findIndex, pipe } from 'ramda'
import classNames from 'classnames'

import TabBar from '@zambezi/sdk/tab-bar'
import { Select } from '@zambezi/sdk/dropdown-list'
import { useStateContext } from '@zambezi/caballo-vivo'
import { IsViewport } from '@zambezi/layout-grid'

import layoutStyle from '../common/api-enabler-styles.module.css'

import PageHeader from './PageHeader'
import NavBar from './NavBar'
import { followStoreLink$ } from '../navigation'
import StandingOrders from './StandingOrders'
import VrpTPPs from './VrpTPPs'
import SweepingTPPs from './SweepingTPPs'

import style from './RecurringPayments.module.scss'

export default function RecurringPayments({ rootPath, paymentType }) {
  const state = useStateContext()

  const tabData = [
    {
      title: 'Variable recurring payments',
      id: 'vrp',
      basePath: 'vrp/tpps',
    },
    {
      title: 'Sweeping payments',
      id: 'sweeping',
      basePath: 'sweeping/tpps',
    },
    {
      title: 'Standing orders',
      id: 'standing-orders',
      basePath: 'standing-orders',
    },
  ]

  const selectedTabIndex = pipe(
    findIndex(tab => tab.id === paymentType),
    index => (index === -1 ? 0 : index)
  )(tabData)

  return (
    <section className="js-payments">
      <PageHeader
        navbar={<NavBar />}
        title="Recurring payments"
        subtitle="A record of the recurring payments you've setup with service providers."
      />
      <div className={layoutStyle.overviewSections}>
        <IsViewport isWidescreen isDesktop>
          <TabBar
            className={classNames(style.tabs, 'js-payment-type-tabs')}
            data={tabData}
            selectedIndex={selectedTabIndex}
            onSelected={({ id }) => {
              const selectedTab = tabData.filter(el => el.id === id)[0]
              followStoreLink$.next(
                `/recurring-payments/${selectedTab.basePath}`
              )
            }}
            renderFn={({ id, title }) => (
              <span
                className={classNames(style.tab, `js-payment-type-tab-${id}`)}
              >
                {title}
              </span>
            )}
          />
        </IsViewport>
        <IsViewport isTablet isMobile>
          <div className={style.paymentType}>
            <span>Select payment type:</span>
            <Select
              aria-label="Select payment type"
              id="paymentsType"
              defaultValue={tabData[selectedTabIndex].title}
              suggestions={tabData.map(paymentType => paymentType.title)}
              className={classNames(
                style.dropdownField,
                'js-payments-type-dropdown'
              )}
              onChange={(event, { value }) => {
                const selectedTab = tabData.filter(el => el.title === value)[0]
                followStoreLink$.next(
                  `/recurring-payments/${selectedTab.basePath}`
                )
              }}
            />
          </div>
        </IsViewport>

        <Switch>
          <Route
            exact
            path={`${rootPath}/recurring-payments/vrp/tpps`}
            render={() => <VrpTPPs />}
          />
          <Route
            exact
            path={`${rootPath}/recurring-payments/sweeping/tpps`}
            render={() => <SweepingTPPs />}
          />
          <Route
            exact
            path={`${rootPath}/recurring-payments/standing-orders`}
            render={() => (
              <StandingOrders standingOrders={state.get('standingOrders')} />
            )}
          />
        </Switch>
      </div>
    </section>
  )
}
